'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Modal = require('../generic/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _LoginForm = require('../login/LoginForm');

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _OrderStatus = require('./OrderStatus');

var _OrderStatus2 = _interopRequireDefault(_OrderStatus);

var _OrderDetail = require('./OrderDetail');

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _Spinner = require('../generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Main = require('../Main');

var _Main2 = _interopRequireDefault(_Main);

var _OrderCard = require('../common/OrderCard');

var _OrderCard2 = _interopRequireDefault(_OrderCard);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY_ORDER_MSG = "You have not placed any order in past.";
var INIT_ORDER_MSG = "Please Wait While We Retrieve Your Recent Orders.";
var LOGIN_MESSAGE = "Please login again & Refresh.";
var ERROR_ORDER_MSG = "Invalid Session Token! Please try again & refresh the browser.";

var NewUserOrders = (0, _createReactClass2.default)({
    displayName: 'NewUserOrders',
    getInitialState: function getInitialState() {
        return {
            // view : {
            //     showLoginModal : false
            // },
            orders: [],
            isLoading: false,
            messageString: INIT_ORDER_MSG
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        if (!_parse2.default.User.current()) {
            this.setState({
                // view : { showLoginModal : true }
                messageString: LOGIN_MESSAGE
            });
        }
    },
    componentDidMount: function componentDidMount() {
        this.getPastOrders(this.props.locId);
        //scroll to top
        window.scrollTo(0, 0);
        Utils.showSpinner();
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
        this.getPastOrders(nextProps.locId);
    },
    getRestaurantAddress: function getRestaurantAddress(locationDetail) {
        if (locationDetail !== null) {
            var locationBar = locationDetail;
            var phoneNumber = locationBar.phoneNumber;
            var addressString1 = locationBar.addLine1;
            var addressString2 = locationBar.city + ', ' + locationBar.state + ' ' + locationBar.zipCode;
            return addressString1 + ',\n ' + addressString2 + '\n ' + Utils.formatPhoneNumber(phoneNumber);
        }
        return null;
    },


    // getTaxInfo(locationDetail) {
    //     if (locationDetail !== null) {
    //         return locationDetail.taxes;
    //     }
    //     return null;
    // },

    getPastOrders: function getPastOrders(locationId) {
        var _this = this;

        var currentUser = _parse2.default.User.current();

        if (locationId && currentUser) {
            var userDetailPtrId = currentUser.id;
            var sessionToken = currentUser.getSessionToken();
            var router = this.props.history;
            var locId = this.props.locId;
            // const bizId               = bizDetail.objectId;
            // const locationDetailPtrId = locationDetail.objectId;
            this.setState({ isLoading: true });
            this.getPastOrdersReq = _Api2.default.getPastOrders(sessionToken, locationId, userDetailPtrId, 50, true).then(function (response) {
                if (response.data) {
                    var rOrders = response.data;
                    if (rOrders && rOrders.length > 0) {
                        _this.setState({
                            isLoading: false,
                            messageString: "",
                            orders: rOrders
                        });
                    } else {
                        _this.setState({
                            isLoading: false,
                            orders: [],
                            messageString: EMPTY_ORDER_MSG
                        });
                    }

                    //hideSpinner
                    Utils.hideSpinner();
                }
            }, function (error) {

                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                console.log(JSON.stringify(error));
                _this.setState({
                    orders: [],
                    messageString: ERROR_ORDER_MSG,
                    isLoading: false
                }, function () {
                    Utils.hideSpinner();
                });
            });
        }
    },
    getOrderLocationDetail: function getOrderLocationDetail(locId) {
        var index = -1;
        var locationDetail = {};

        if (!Utils.isEmptyObj(_MainStore2.default.data) && _MainStore2.default.data.hasOwnProperty("BusinessLocations")) {
            locationDetail = _MainStore2.default.data.BusinessLocations.filter(function (location, idx) {
                if (location.objectId == locId) {
                    index = idx;
                    return true;
                }
            })[0];
        }

        return { locationDetail: locationDetail, index: index };
    },
    routeToHome: function routeToHome() {
        var history = this.props.history;

        var locId = this.props.locId;
        // Navigate to Another Component
        history.push({
            pathname: '/location/' + locId,
            resetStore: false
        });
    },
    render: function render() {
        var _this2 = this;

        var self = this;
        var title = "Please login/signup to see your Orders";
        var logo = Utils.getLogoUrl(this.props.businessData);

        var component = _react2.default.createElement(
            'div',
            { className: "p-4 order-sidebar bg-white shadow-sm order-box" },
            _react2.default.createElement(
                'h4',
                { className: 'font-weight-bold mt-0 mb-4 d-inline-block' },
                'Past Orders'
            ),
            _react2.default.createElement(
                'div',
                { className: "pull-right" },
                _react2.default.createElement(
                    'div',
                    { className: "d-inline-block" },
                    _react2.default.createElement(_SpinButton2.default, {
                        classNames: 'btn btn-sm btn-styl font-weight-bold'
                        // classNames="btn btn-sm custom-btn-outline-primary font-weight-bold"
                        , buttonText: 'Back to Menu',
                        spinText: "Loading...",
                        showSpinner: false,
                        whenClicked: this.routeToHome,
                        showIcon: true,
                        iconClass: "icofont-circled-left fr-10 mr-1",
                        tabIndex: 11
                    })
                )
            ),
            this.state.orders.map(function (order, idx) {

                var orderLocId = order.locationDetailPointer.objectId;

                var _getOrderLocationDeta = _this2.getOrderLocationDetail(orderLocId),
                    locationDetail = _getOrderLocationDeta.locationDetail;

                if (!Utils.isEmptyObj(locationDetail) && locationDetail != undefined) {

                    return _react2.default.createElement(
                        'div',
                        { key: idx + 'od' + order.objectId },
                        _react2.default.createElement(_OrderCard2.default, {
                            image: '/img/3.jpg',
                            imageAlt: '',
                            orderNumber: '2510258',
                            orderDate: 'Mon, Nov 12, 6:26 PM',
                            deliveredDate: 'Mon, Nov 12, 7:18 PM',
                            orderTitle: 'Gus\'s World Famous Fried Chicken',
                            address: '730 S Mendenhall Rd, Memphis, TN 38117, USA',
                            orderProducts: 'Veg Masala Roll x 1, Veg Burger x 1, Veg Penne Pasta in Red Sauce x 1',
                            orderTotal: '$300',
                            resAddress: self.getRestaurantAddress(locationDetail),
                            order: order,
                            locationDetail: locationDetail,
                            locId: _this2.props.locId,
                            history: _this2.props.history,
                            index: idx
                            // helpLink='#'
                            // detailLink='/detail'
                        })
                    );
                }
            }),
            this.state.messageString ? _react2.default.createElement(
                'h5',
                { className: 'text-center' },
                this.state.messageString
            ) : null
        );
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_Spinner2.default, null),
            component
        );
    }
});

exports.default = NewUserOrders;


//////////////////
// WEBPACK FOOTER
// ./src/components/order/NewUserOrders.jsx
// module id = 544
// module chunks = 0